module.exports = __webpack_public_path__ + "img/tie-rod.6581ee25.jpg";